import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/loader/report/styles.scss';export default {
  "report": "_report_1uum8_1"
};